// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/company_permission_override.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/company_permission_override.proto.
 */
export const file_api_proto_v1_company_permission_override: GenFile = /*@__PURE__*/
  fileDesc("Ci5hcGlfcHJvdG8vdjEvY29tcGFueV9wZXJtaXNzaW9uX292ZXJyaWRlLnByb3RvEgxhcGlfcHJvdG8udjEilAEKHUNvbXBhbnlQZXJtaXNzaW9uT3ZlcnJpZGVJdGVtEhIKCmNvbXBhbnlfaWQYASABKAMSFwoPcGVybWlzc2lvbl9jb2RlGAIgASgJEhQKDGFjY2Vzc19sZXZlbBgDIAEoCRIOCgZyZWFzb24YBCABKAkSDwoHY3JlYXRlZBgFIAEoCRIPCgd1cGRhdGVkGAYgASgJIjsKJUxpc3RDb21wYW55UGVybWlzc2lvbk92ZXJyaWRlc1JlcXVlc3QSEgoKY29tcGFueV9pZBgBIAEoAyJoCiZMaXN0Q29tcGFueVBlcm1pc3Npb25PdmVycmlkZXNSZXNwb25zZRI+CglvdmVycmlkZXMYASADKAsyKy5hcGlfcHJvdG8udjEuQ29tcGFueVBlcm1pc3Npb25PdmVycmlkZUl0ZW0ieAojU2V0Q29tcGFueVBlcm1pc3Npb25PdmVycmlkZVJlcXVlc3QSEgoKY29tcGFueV9pZBgBIAEoAxIXCg9wZXJtaXNzaW9uX2NvZGUYAiABKAkSFAoMYWNjZXNzX2xldmVsGAMgASgJEg4KBnJlYXNvbhgEIAEoCSJlCiRTZXRDb21wYW55UGVybWlzc2lvbk92ZXJyaWRlUmVzcG9uc2USPQoIb3ZlcnJpZGUYASABKAsyKy5hcGlfcHJvdG8udjEuQ29tcGFueVBlcm1pc3Npb25PdmVycmlkZUl0ZW0iZQomRGVsZXRlQ29tcGFueVBlcm1pc3Npb25PdmVycmlkZVJlcXVlc3QSEgoKY29tcGFueV9pZBgBIAEoAxIXCg9wZXJtaXNzaW9uX2NvZGUYAiABKAkSDgoGcmVhc29uGAMgASgJIikKJ0RlbGV0ZUNvbXBhbnlQZXJtaXNzaW9uT3ZlcnJpZGVSZXNwb25zZUIzWjFnaXRodWIuY29tL2gtc2NhcGUvaWVzYXB1cmkvZ28vYXBpX3Byb3RvL3YxO2FwaXYxYgZwcm90bzM");

/**
 * 企業単位の権限上書き 1 件
 *
 * @generated from message api_proto.v1.CompanyPermissionOverrideItem
 */
export type CompanyPermissionOverrideItem = Message<"api_proto.v1.CompanyPermissionOverrideItem"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * go/logic/permissioncode の Code（例 crm.line_deal_operation）
   *
   * @generated from field: string permission_code = 2;
   */
  permissionCode: string;

  /**
   * none（明示的な剥奪） / full
   *
   * @generated from field: string access_level = 3;
   */
  accessLevel: string;

  /**
   * 設定理由（必須）
   *
   * @generated from field: string reason = 4;
   */
  reason: string;

  /**
   * RFC3339
   *
   * @generated from field: string created = 5;
   */
  created: string;

  /**
   * RFC3339
   *
   * @generated from field: string updated = 6;
   */
  updated: string;
};

/**
 * Describes the message api_proto.v1.CompanyPermissionOverrideItem.
 * Use `create(CompanyPermissionOverrideItemSchema)` to create a new message.
 */
export const CompanyPermissionOverrideItemSchema: GenMessage<CompanyPermissionOverrideItem> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_permission_override, 0);

/**
 * @generated from message api_proto.v1.ListCompanyPermissionOverridesRequest
 */
export type ListCompanyPermissionOverridesRequest = Message<"api_proto.v1.ListCompanyPermissionOverridesRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;
};

/**
 * Describes the message api_proto.v1.ListCompanyPermissionOverridesRequest.
 * Use `create(ListCompanyPermissionOverridesRequestSchema)` to create a new message.
 */
export const ListCompanyPermissionOverridesRequestSchema: GenMessage<ListCompanyPermissionOverridesRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_permission_override, 1);

/**
 * @generated from message api_proto.v1.ListCompanyPermissionOverridesResponse
 */
export type ListCompanyPermissionOverridesResponse = Message<"api_proto.v1.ListCompanyPermissionOverridesResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.CompanyPermissionOverrideItem overrides = 1;
   */
  overrides: CompanyPermissionOverrideItem[];
};

/**
 * Describes the message api_proto.v1.ListCompanyPermissionOverridesResponse.
 * Use `create(ListCompanyPermissionOverridesResponseSchema)` to create a new message.
 */
export const ListCompanyPermissionOverridesResponseSchema: GenMessage<ListCompanyPermissionOverridesResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_permission_override, 2);

/**
 * 企業単位の権限上書きを作成・更新する（permission_code 単位で全置換。既存の上書きがあれば差し替える）
 *
 * @generated from message api_proto.v1.SetCompanyPermissionOverrideRequest
 */
export type SetCompanyPermissionOverrideRequest = Message<"api_proto.v1.SetCompanyPermissionOverrideRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * @generated from field: string permission_code = 2;
   */
  permissionCode: string;

  /**
   * none / full のみ（readonly は拒否）
   *
   * @generated from field: string access_level = 3;
   */
  accessLevel: string;

  /**
   * 必須
   *
   * @generated from field: string reason = 4;
   */
  reason: string;
};

/**
 * Describes the message api_proto.v1.SetCompanyPermissionOverrideRequest.
 * Use `create(SetCompanyPermissionOverrideRequestSchema)` to create a new message.
 */
export const SetCompanyPermissionOverrideRequestSchema: GenMessage<SetCompanyPermissionOverrideRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_permission_override, 3);

/**
 * @generated from message api_proto.v1.SetCompanyPermissionOverrideResponse
 */
export type SetCompanyPermissionOverrideResponse = Message<"api_proto.v1.SetCompanyPermissionOverrideResponse"> & {
  /**
   * @generated from field: api_proto.v1.CompanyPermissionOverrideItem override = 1;
   */
  override?: CompanyPermissionOverrideItem;
};

/**
 * Describes the message api_proto.v1.SetCompanyPermissionOverrideResponse.
 * Use `create(SetCompanyPermissionOverrideResponseSchema)` to create a new message.
 */
export const SetCompanyPermissionOverrideResponseSchema: GenMessage<SetCompanyPermissionOverrideResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_permission_override, 4);

/**
 * 企業単位の上書きを解除する（契約・プラン権限の既定へ戻す）
 *
 * @generated from message api_proto.v1.DeleteCompanyPermissionOverrideRequest
 */
export type DeleteCompanyPermissionOverrideRequest = Message<"api_proto.v1.DeleteCompanyPermissionOverrideRequest"> & {
  /**
   * @generated from field: int64 company_id = 1;
   */
  companyId: bigint;

  /**
   * @generated from field: string permission_code = 2;
   */
  permissionCode: string;

  /**
   * 必須（解除も監査ログに理由を残す）
   *
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * Describes the message api_proto.v1.DeleteCompanyPermissionOverrideRequest.
 * Use `create(DeleteCompanyPermissionOverrideRequestSchema)` to create a new message.
 */
export const DeleteCompanyPermissionOverrideRequestSchema: GenMessage<DeleteCompanyPermissionOverrideRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_permission_override, 5);

/**
 * @generated from message api_proto.v1.DeleteCompanyPermissionOverrideResponse
 */
export type DeleteCompanyPermissionOverrideResponse = Message<"api_proto.v1.DeleteCompanyPermissionOverrideResponse"> & {
};

/**
 * Describes the message api_proto.v1.DeleteCompanyPermissionOverrideResponse.
 * Use `create(DeleteCompanyPermissionOverrideResponseSchema)` to create a new message.
 */
export const DeleteCompanyPermissionOverrideResponseSchema: GenMessage<DeleteCompanyPermissionOverrideResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_company_permission_override, 6);

